/** O endereço antigo da Anomalia Noturna, `/logistica/frota-leve/anomalias`, abre a
 *  Anomalia Frota na aba Frota Leve, com a busca junto (Samuel, 04/11/2026). Link
 *  guardado e o voltar do Ver rastro continuam caindo na mesma lista. */
import { Navigate, useLocation } from 'react-router-dom'
import { ROTA_DA_ANOMALIA_FROTA } from './rota'

export function RedirecionarAnomaliaNoturna() {
  const { search, hash } = useLocation()
  const sp = new URLSearchParams(search)
  if (!sp.has('aba')) sp.set('aba', 'leve')
  return <Navigate to={`${ROTA_DA_ANOMALIA_FROTA}?${sp.toString()}${hash}`} replace />
}
